import React from 'react';
import { MessageCircle, Calculator, Search, Handshake } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: MessageCircle,
      title: 'Intro Call',
      description: 'A 30-minute conversation to understand how did you start, current operations and reason to sell'
    },
    {
      number: '02',
      icon: Calculator,
      title: 'Initial Valuation & First Offer',
      description: 'A data-driven valuation range, delivered within 2-4 days if we like the business'
    },
    {
      number: '03',
      icon: Search,
      title: 'Diligence & Terms',
      description: 'Transparent review. No surprises. Revised offer terms based on what the numbers actually say.'
    },
    {
      number: '04',
      icon: Handshake,
      title: 'Close & Transition',
      description: 'Respectful handover. Most deals close in under 3 weeks. Your legacy continues.'
    }
  ];

  return (
    <section id="our-process" className="py-24 md:py-32 bg-[#F5F0EB] px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4D3E] mb-6"
            style={{fontFamily: 'Space Grotesk, sans-serif'}}
          >
            Our seller-friendly process.
          </h2>
          <p className="text-lg text-[#7A746E] max-w-3xl">
            No six-month marathons. No death-by-a-thousand-NDAs. Here's how it actually works.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="space-y-4">
                <div className="text-5xl font-bold text-[#1B4D3E] opacity-30" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
                  {step.number}
                </div>
                <Icon className="w-12 h-12 text-[#1B4D3E]" strokeWidth={2} />
                <h3 
                  className="text-xl font-bold text-[#1B4D3E]"
                  style={{fontFamily: 'Space Grotesk, sans-serif'}}
                >
                  {step.title}
                </h3>
                <p className="text-base text-[#2C2C2C] leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;